/**
 * "One of the three I bid", rendered.
 *
 * A `seatTally` is two per-seat numbers that only mean something together —
 * what has happened against what was asked for. Two places show it, the ring
 * and the standings panel, and they each had their own copy of the rule.
 *
 * The rule includes a convention that is game knowledge leaking into a generic
 * renderer, and it is stated once here rather than twice so the two cannot
 * drift: **a target below zero means "not answered yet"**. Oh Hell carries an
 * unbid seat as `-1`, and rendering that raw gives "0/-1".
 *
 * Zero is NOT the test. A bid of zero is a real bid and a common one, so
 * falsiness would hide the boldest call in the game.
 */

/** Shown where a target has been set but not yet answered. */
export const UNANSWERED = '—';

/**
 * Format one seat's tally, or null when this game has nothing to show there.
 *
 * Takes the two raw view values rather than the view, so it stays pure and the
 * callers keep their own field lookups.
 */
export function tallyText(value: unknown, target: unknown): string | null {
  if (typeof target !== 'number') return null;
  if (target < 0) return UNANSWERED;
  const taken = typeof value === 'number' ? value : 0;
  return `${String(taken)}/${String(target)}`;
}
